import(/* webpackMode: "eager", webpackExports: ["PlatformPageContent"] */ "/vercel/path0/src/components/inbound-gpt/product-pages.tsx");
